export interface BatchCollectionMgmtBibliographyBulkRemovalRequest {
  registDateFrom: string
  registDateTo: string
  marcType: string
  marcNoFrom: string
  marcNoTo: string
  materialFormat: string
  rdoSearchType: string
  rdoRemovalTarget: string
  rdoDatabaseUpdate: string
  memo: string
  batchType: string
}

export function BatchCollectionMgmtBibliographyBulkRemovalRequestToJSON(
  value: BatchCollectionMgmtBibliographyBulkRemovalRequest
): any {
  return {
    regist_date_from: value.registDateFrom,
    regist_date_to: value.registDateTo,
    marc_type: value.marcType,
    marc_no_from: value.marcNoFrom,
    marc_no_to: value.marcNoTo,
    material_format: value.materialFormat,
    rdo_search_type: value.rdoSearchType,
    rdo_removal_target: value.rdoRemovalTarget,
    rdo_database_update: value.rdoDatabaseUpdate,
    memo: value.memo,
    batch_type: value.batchType
  }
}
